import http from '../http'


export function get(name) {
  return http.get("/v1/features", {params: { name }, withCredentials: true})
}
